import { FC, useContext } from 'react';
import { CbButton } from 'ui/components/Buttons/CbButton';
import { ICON_BY_NAME } from '../Icons/Icon';
import { TableContext, TableDrawerName } from './';
import styles from './CbTable.module.css';
export const ColumnVisibility: FC = () => {
  const {
    columnInfo: {
      allColumns
    },
    setDrawer
  } = useContext(TableContext);

  // Don't show button if there won't be any hideable columns
  if (allColumns.every(col => col.primary || !col.name)) return null;
  const onClick = () => setDrawer({
    name: TableDrawerName.ColumnVisibility
  });
  return <CbButton onClick={onClick} size="sm" variant="outline" data-sentry-element="CbButton" data-sentry-component="ColumnVisibility" data-sentry-source-file="ColumnVisibility.tsx">
      <span className={styles.buttonContent}>
        <ICON_BY_NAME.columns boxSize="20px" data-sentry-element="unknown" data-sentry-source-file="ColumnVisibility.tsx" />
        Columns
      </span>
    </CbButton>;
};